import { endpoints, idp } from '../app/shared/constants/auth.constants';

const { 
  tbtDomainUrl, heqPortaledirectionUrl, dataDomainScript, proxyApi, 
  apiGatewayResourceId, apiGatewayVPCEndpointId, awsRegion
} = idp.uat;

const scope = idp.scope;

const oauth2AuthorizePath = '/oauth2/authorize';
const responseType = 'CODE';

// const pingfedAuthUrl = `${cognitoDomainUrl}${oauth2AuthorizePath}?identity_provider=${cognitoIdentityProvider}&redirect_uri=${cognitoRedirectUrl}&response_type=${responseType}&client_id=${cognitoClientId}&scope=${scope}`;

export const environment = {
  production: false,
  redirectUri: `${tbtDomainUrl}/verify-token`,
  redirectUriLogout: `${tbtDomainUrl}/sign-out`,
  designsEndPoint: `/services/apexrest/${endpoints.designs}`,
  templatesEndPoint: `/services/apexrest/${endpoints.templates}`,
  apiGatewayUrl: `https://${apiGatewayResourceId}-${apiGatewayVPCEndpointId}.execute-api.${awsRegion}.amazonaws.com/v1/`,
  apiProxyApi: proxyApi,
  portalRedirectLink: heqPortaledirectionUrl,
  dataDomainScript
 };